<template>
  <div :key="accessDialog" class="dCon">
    <div :class="isLockedClass()">
      <div class="title"> Resources</div>
      <div class="summary">
        Use the filter menu to find what you are looking for.
        Click on ‘select filter’ to see a list of manufacturing themes.
        Click on the relevant theme to see a list of resources available for the processes within that theme.
        Press the download icon to download the resource to your computer.
      </div>
      <div class="AcContainer">
        <auto-complete-component v-if="!locked" @selected="selectedResource"></auto-complete-component>
      </div>
      <div>
        <ListComponent v-if="this.resource  " :items="this.resource"></ListComponent>
      </div>
    </div>
    <div v-if="locked" class="lockView">
     <div  class="lockedTitle"> This area is locked.</div>
      <span class="lockedSummary"> You need to authenticate yourself to gain access to these resources.</span>

      <button class="lockBtn" @click="requestAccess">
        <div class="lockBtnText" >Request Access </div>
      </button>
    </div>
    <UnlockComponent :key="accessDialog" v-on:unlock="unlock()" @close="closedUnlock"  v-if="accessDialog" class="dialog"></UnlockComponent>
    <RegisterModal v-if="registerModal" @close="closedRegister" class="dialog"></RegisterModal>
  </div>
</template>

<script>
import UnlockComponent from "@/components/UnlockComponent";
import AutoCompleteComponent from "@/components/AutocompleteComponent"
import ListComponent from "@/components/ListComponent";
import RegisterModal from "@/components/modals/RegisterModal";
import axios from "axios";
export default {
  name: "ResourcesComponent.vue",
  props: [],
  data: () => {
    return {
      hover: false,
      locked: true,
      accessDialog: false,
      resource: null,
      registerModal: false
    }
  },
  mounted() {
    this.isLocked();
  },
  methods: {
    closedUnlock(ev){
      if(ev === "register"){
        //show register dialog
        this.registerModal = true;
      }
      else{
        //just close
        this.accessDialog = false;
        this.isLocked();
      }
    },
    isLocked(){
      //if there is an token and it has not expired then the component is unlocked
      //check with api endpoint that cookie is valid there
      axios.post(process.env.VUE_APP_API_URL+'/wl-authenticate', {
        email: this.getCookie('email'),
        token: this.getCookie('usertoken')
      },{headers:{'Content-Type': 'application/json'}}).then((response)=>{
        console.log(response);
        if(response.data.state && response.data.state === 1){
          //auth success
          this.locked=false;
        }
        else if(response.data.state && response.data.state === 2){
          //token expired
        }
        else {
          //no auth
        }
      }).catch((error)=>{
        console.log("error", error)

      })
    },
  isLockedClass(){
    if(this.locked){
      return "resourcesContainer locked";
    } else {
      return "resourcesContainer ";
    }
  },
    unlock(){
    this.accessDialog = false;
    this.locked = false;
    },
    requestAccess(){
      this.accessDialog = true;
    },
    closedRegister(){
      this.registerModal = false;
    },

    selectedResource(ev){
      axios.get(process.env.VUE_APP_API_URL+'/resources/'+ ev.id, {
            headers: {
              'Content-Type': 'application/json',
              'email': this.getCookie('email'),
              'usertoken': this.getCookie('usertoken')
            }
          }).then((response)=>{
        if(response && response.data){

          this.resource = response.data;
        }

      }).catch((error)=>{
        console.log("error", error)
      })
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
},
  components: {
    UnlockComponent,
    ListComponent,
    AutoCompleteComponent,
    RegisterModal
  }
}
</script>

<style scoped>
.resourcesContainer{
  background: #EFEFF4;
  height: 100%;
  width: 100%;
  font-family: RRPioneer;
}

.title{
  color: #10069F;
  font-size: 28px;
  margin: 60px 0 0 45px;

}
.lockedTitle{
  color: #10069F;
  font-size: 28px;
}
.summary{
  color: #8A8A8F;
  font-size: 22px;
  margin: 35px 0 0 45px;
}
.lockedSummary{
  text-align: center;
  width: 522px;
  color: #8A8A8F;
  font-size: 22px;
  margin-top: 34px;
}
.locked{
  filter: blur(4px);
}
.lockView{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.lockBtn{
  border: 1px solid #006DFF;
  color: #006DFF;
  height: 80px;
  margin-top: 70px;
}
.lockBtnText{
  font-size: 24px;

}
.dialog{
  position: absolute;
  top: 25%;
  background: white;
  left: 25%;
  box-shadow: 5px 10px 18px #888888;
  border-radius: 15px;
}
.AcContainer{
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>